export enum SearchTheme {
  Classic = 'classic',
  StrongBorder = 'strongBorder',
  NoBorder = 'noBorder'
}
